import { render, staticRenderFns } from "./order-dispatch.vue?vue&type=template&id=3bd75eda&scoped=true&"
import script from "./order-dispatch.vue?vue&type=script&lang=js&"
export * from "./order-dispatch.vue?vue&type=script&lang=js&"
import style0 from "./order-dispatch.vue?vue&type=style&index=0&id=3bd75eda&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd75eda",
  null
  
)

export default component.exports